import { ACCESS_RIGHTS, COMPANY_TYPES, GENDER } from '../../resources/enums';
import { Company } from '../../resources/types';
import { safeDate } from '../../utilities/miscFunctions';
import { Branch, IBranch } from './branch/Branch';
import { ITransaction, Transaction } from './transaction/Transaction';
import { IUserAccount } from './UserAccount';

export class User {
  id: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  email: string;
  profileImage?: string;
  jobTitle?: string;
  username?: string;
  gender?: GENDER | undefined;
  phone?: string;
  city?: string;
  country?: ICountry;
  role?: ACCESS_RIGHTS;
  account?: IUserAccount;
  teamName?: string;
  isActive?: boolean;
  accountActivatedAt: Date | null;
  emailVerifiedAt: Date | null;
  company: Company | null;
  transactions?: Transaction[];
  branch: Branch | null;
  createdAt: Date | null
  updatedAt: Date | null;
  branch_id?: string;
  recentTransactions?: Transaction[];

  constructor(IUserModel: IUser) {
    this.id = IUserModel.id;
    this.firstName = IUserModel.first_name ?? '';
    this.lastName = IUserModel.last_name ?? '';
    this.fullName = IUserModel.full_name ?? `${this.firstName} ${this.lastName}`;
    this.email = IUserModel.email ?? '';
    this.profileImage = IUserModel.avatar_url ?? '';
    this.jobTitle = IUserModel.job_title ?? '';
    this.username = IUserModel.username ?? '';
    this.gender = IUserModel.gender;
    this.phone = IUserModel.phone ?? '';
    this.city = IUserModel.city ?? '';
    this.country = IUserModel.country;
    this.role = IUserModel?.role ?? undefined;
    this.account = IUserModel.account ?? null;
    this.isActive = IUserModel.is_active;
    this.accountActivatedAt = IUserModel.account_activated_at ? new Date(IUserModel.account_activated_at) : null;
    this.emailVerifiedAt = IUserModel.email_verified_at ? new Date(IUserModel.email_verified_at) : null;
    this.company = IUserModel.company ?? null;
    this.transactions = IUserModel.transactions ? IUserModel.transactions.map((transaction: ITransaction) => new Transaction(transaction)) : [];
    this.branch = IUserModel.branch ? new Branch(IUserModel.branch) : null;
    this.createdAt = safeDate(IUserModel.created_at ?? null)
    this.updatedAt = safeDate(IUserModel.updated_at ?? null);
    this.branch_id = IUserModel.branch_id;
    this.recentTransactions = IUserModel.recent_transactions ? IUserModel.recent_transactions.map((transaction: ITransaction) => new Transaction(transaction)) : [];
  }

  isAdmin(): boolean {
    return this.role === ACCESS_RIGHTS.ADMIN;
  }

  isOwner(): boolean {
    return this.role === ACCESS_RIGHTS.OWNER;
  }

  isAgent(): boolean {
    return this.role === ACCESS_RIGHTS.AGENT;
  }

  isManager(): boolean {
    return this.role === ACCESS_RIGHTS.MANAGER;
  }

  isInternal(): boolean {
    return this.company?.type === COMPANY_TYPES.INTERNAL;
  }
}

export interface IUser {
  id: string;
  first_name: string;
  last_name: string;
  full_name?: string;
  email: string;
  job_title?: string;
  username?: string;
  gender?: GENDER;
  phone?: string;
  city?: string;
  role?: ACCESS_RIGHTS;
  team_name?: string;
  referral_code?: string;
  account?: any;
  country?: ICountry;
  last_seen?: string;
  verified?: boolean;
  avatar_url?: string;
  is_active?: boolean;
  account_activated_at?: string | null;
  email_verified_at?: string | null;
  company: Company | null;
  transactions?: ITransaction[];
  branch?: IBranch;
  created_at?: string;
  updated_at?: string;
  branch_id?: string;
  recent_transactions?: ITransaction[];
}

export interface ICountry {
  name: string;
  code: string;
  iso: string;
  language: string;
  currencySymbol: string;
  currencyIso: string;
  flag: string;
}
